/** Deterministic accent for letter avatars (readable on white text). */
export function stringToAvatarColor(str) {
  const s = String(str || "user");
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) {
    hash = s.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = Math.abs(hash) % 360;
  return `hsl(${h} 48% 40%)`;
}

export function avatarInitial(name) {
  const n = String(name || "?").trim();
  return n ? n.charAt(0).toUpperCase() : "?";
}

/** First letter of the first name (e.g. "Jane Doe" → "J"). */
export function firstNameInitial(name) {
  const n = String(name || "").trim();
  if (!n) return "?";
  const first = n.split(/\s+/)[0];
  return first.charAt(0).toUpperCase();
}

/**
 * Mentor linked to Google (profile CDN URL) or created via Google login
 * (empty password). Used only for UI hints in admin.
 */
export function isGoogleLinkedUser(row) {
  if (!row || typeof row !== "object") return false;
  if (row.google_sub) return true;
  const url = row.avatar_url;
  if (url && /googleusercontent\.com|ggpht\.com/i.test(String(url))) {
    return true;
  }
  if (row.role !== "mentor") return false;
  const pwd = row.password;
  const noPassword =
    pwd === null ||
    pwd === undefined ||
    (typeof pwd === "string" && pwd.trim() === "");
  return Boolean(row.email && noPassword);
}
